import {
    KYC_MAX_CARDS,
    KYC_MAX_PURCHASE_AMOUNT,
    MAX_CARDS,
    MAX_PURCHASE_AMOUNT,
    minCardLoad,
    minCards,
    minPGPlusCardLoad,
} from '@/src/modules/checkout/strings'
import * as yup from 'yup'
import { emailMax } from '@/src/modules/build-a-card/constants'
import { singleRecipientPhoneSchema } from '../../build-a-card/validations/schemas'

const createCheckoutValidationSchema = (
    hasPGPlusItem: boolean,
    isKYCAndNotRejected: boolean,
    virtualLineItemEmails = [],
    allowSelfGifting: boolean
) => {
    const maxLoadValue: number = isKYCAndNotRejected
        ? KYC_MAX_PURCHASE_AMOUNT
        : MAX_PURCHASE_AMOUNT
    const maxCardsAllowed: number = isKYCAndNotRejected
        ? KYC_MAX_CARDS
        : MAX_CARDS

    const checkoutSchema = {
        email: yup
            .string()
            .label('Email')
            .trim()
            // Final validation is controlled by the Stripe LinkAuthenticationElement
            .required('A valid email address is required')
            .email('A valid email address is required')
            .max(
                emailMax,
                `Email cannot contain more than ${emailMax} characters`
            )
            .test(
                'validate-self-gift',
                'Sending a gift to yourself is not permitted. Please change the gift recipient email address or the billing email address and re-submit your order.',
                function (email) {
                    // if user is in white label partner flow, let them self-gift
                    if (allowSelfGifting) {
                        return true
                    }

                    return !virtualLineItemEmails?.some(
                        (lineItemEmail: string) => {
                            return (
                                lineItemEmail.toLowerCase() ===
                                email?.toLowerCase()
                            )
                        }
                    )
                }
            ),
        agreedToTerms: yup
            .boolean()
            .required('Please review and agree to the Terms to continue.')
            .oneOf([true], 'Please review and agree to the Terms to continue.'),
        totalLoadValue: yup
            .number()
            .min(
                hasPGPlusItem ? minPGPlusCardLoad : minCardLoad,
                `Your total gift card load value must be larger than $${
                    hasPGPlusItem ? minPGPlusCardLoad : minCardLoad
                }.`
            )
            .max(
                maxLoadValue,
                `Your total gift card load value cannot be larger than $${maxLoadValue}.`
            ),
        numberOfCards: yup
            .number()
            .min(
                minCards,
                `Your cart must include at least ${minCards} gift card.`
            )
            .max(
                maxCardsAllowed,
                `Your cart cannot include more than ${maxCardsAllowed} gift cards.`
            ),
    }

    return singleRecipientPhoneSchema.shape(checkoutSchema)
}
export default createCheckoutValidationSchema
